import instoreMultiLinkModal from './instoreMultiLinkModal';

export default instoreMultiLinkModal;
